import React from "react";
import { useDispatch } from "react-redux";
import { setActiveBranch } from "../../../store/businessSlice";

const COLORS = {
  blue: '#96C5F7',
  gray: '#5B6B79',
};

const BranchSelectorModal = ({ branches, onSelect }) => {
  const dispatch = useDispatch();

  const handleSelect = (branch) => {
    dispatch(setActiveBranch(branch));
    if (onSelect) onSelect(branch);
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: '32px 28px',
        width: '100%', maxWidth: 480, boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{
            width: 48, height: 48, borderRadius: 12, background: `${COLORS.blue}20`,
            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px',
          }}>
            <i className="ti ti-building-store" style={{ fontSize: 24, color: COLORS.blue }} />
          </div>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#1a202c' }}>Select Your Branch</div>
          <div style={{ fontSize: 13, color: COLORS.gray, marginTop: 4 }}>
            Choose the branch you are working in today
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: branches.length > 2 ? '1fr 1fr' : '1fr '.repeat(branches.length).trim(), gap: 12 }}>
          {branches.map((branch, idx) => (
            <button
              key={branch.id}
              type="button"
              onClick={() => handleSelect(branch)}
              style={{
                padding: '16px 12px', borderRadius: 12,
                border: `1.5px solid #e8ecf0`, background: '#fafbfc',
                cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = COLORS.blue;
                e.currentTarget.style.background = `${COLORS.blue}12`;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = '#e8ecf0';
                e.currentTarget.style.background = '#fafbfc';
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                <div style={{
                  width: 28, height: 28, borderRadius: 8, background: `${COLORS.blue}20`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>
                  <i className="ti ti-building" style={{ fontSize: 14, color: COLORS.blue }} />
                </div>
                <span style={{ fontSize: 13, fontWeight: 700, color: '#1a202c' }}>Branch {idx + 1}</span>
              </div>
              {branch.official_name && (
                <div style={{ fontSize: 12, color: '#1a202c', fontWeight: 600, marginBottom: 2 }}>
                  {branch.official_name}
                </div>
              )}
              {branch.address && (
                <div style={{ fontSize: 11, color: COLORS.gray }}>
                  <i className="ti ti-map-pin" style={{ fontSize: 10, marginRight: 3 }} />
                  {branch.address}
                </div>
              )}
              {!branch.official_name && !branch.address && (
                <div style={{ fontSize: 11, color: COLORS.gray }}>No details configured yet</div>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BranchSelectorModal;
